var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenInner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7062 0H4.29375C3.15539 0.00133981 2.06403 0.454146 1.25909 1.25909C0.454146 2.06403 0.00133981 3.15539 0 4.29375L0 27.7062C0.00130679 28.8446 0.454102 29.936 1.25905 30.7409C2.064 31.5459 3.15538 31.9987 4.29375 32H27.7062C28.8446 31.9987 29.936 31.5459 30.741 30.741C31.5459 29.936 31.9987 28.8446 32 27.7062V4.29375C31.9987 3.15539 31.5459 2.06403 30.7409 1.25909C29.936 0.454146 28.8446 0.00133981 27.7062 0Z",
    fill: "#DFDBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_10511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.334 9.9976C19.5091 9.8225 19.7169 9.68361 19.9457 9.58885C20.1745 9.49409 20.4197 9.44531 20.6673 9.44531C20.9149 9.44531 21.1601 9.49409 21.3889 9.58885C21.6177 9.68361 21.8256 9.8225 22.0007 9.9976C22.1757 10.1727 22.3146 10.3806 22.4094 10.6093C22.5042 10.8381 22.5529 11.0833 22.5529 11.3309C22.5529 11.5786 22.5042 11.8238 22.4094 12.0525C22.3146 12.2813 22.1757 12.4892 22.0007 12.6643L13.0007 21.6643L9.33398 22.6643L10.334 18.9976L19.334 9.9976Z",
    stroke: "#5A4AD5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_10511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenInner);
export default __webpack_public_path__ + "static/media/pen_inner.6394499797c22ee89c8e053753137c36.svg";
export { ForwardRef as ReactComponent };